exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mypage-logo[data-v-67164fea]{width:133px;position:absolute;top:-5px;left:80px}.navbar[data-v-67164fea]{height:60px}", ""]);

// exports
